import React, { Component } from 'react';
import { Rate as AntdRate } from 'antd';
import classNames from 'classnames';
import { RateProps as AntRateProps } from 'antd/lib/rate';
import { ThemeContext } from 'app-themes';
import { Icon } from 'antd';

import styles from './Rate.module.scss';

export interface RateProps extends AntRateProps {
	size?: 'large';
}

// In order to use Rate component and background gradient for icons - star icons are displayed using CSS and not a Icon component
const EmptyComponent = () => null;

export class Rate extends Component<RateProps> {
	static contextType = ThemeContext;

	render() {
		const theme = this.context;
		const { className, ...restProps } = this.props;

		return (
			<AntdRate
				character={<Icon component={EmptyComponent} />}
				className={classNames(styles.rate, className, {
					[styles.large]: this.props.size === 'large',
					[styles[`rate-${theme}`]]: theme !== '',
				})}
				{...restProps}
			/>

		);
	}
}

export default Rate;
